import { forwardRef } from 'react';
import {
  AppContainer,
  Page,
  PageBody,
  PageHeading,
  PageHeadingText,
  PortfolioSection,
  PortfolioSectionHeader,
  PortfolioSectionBody,
  PortfolioSectionItem,
  PortfolioBody,
  PortfolioSectionItemLink,
  PortfolioSectionItemHeader,
  PortfolioSectionItemDescription,
  PortfolioText,
} from '../components/styled';

export const Portfolio = forwardRef(({ height }, ref) => {
  return (
    <AppContainer ref={ref} height={height} id="portfolio">
      <Page>
        <PageHeading>
          <PageHeadingText>My Work</PageHeadingText>
        </PageHeading>
        <PageBody>
          <PortfolioBody>
            <PortfolioText>
              Here is a list of projects that I have worked on for customers and my own curiosity.
              Due to my interest in networking and C++, a lot projects are implementation of RFCs.
            </PortfolioText>
            <PortfolioSection>
              <PortfolioSectionHeader>Published Work</PortfolioSectionHeader>
              <PortfolioSectionBody>
                <PortfolioSectionItem>
                  <PortfolioSectionItemHeader>DayOne ProTracker</PortfolioSectionItemHeader>
                  <PortfolioSectionItemDescription></PortfolioSectionItemDescription>
                  <PortfolioSectionItemLink
                    target="_blank"
                    rel="noreferrer"
                    href="https://protracker.dayonesolutionsinc.com/"
                  >
                    Go to Project
                  </PortfolioSectionItemLink>
                </PortfolioSectionItem>
                <PortfolioSectionItem>
                  <PortfolioSectionItemHeader>
                    Smart Energy 2030 - Report Portal
                  </PortfolioSectionItemHeader>
                  <PortfolioSectionItemDescription></PortfolioSectionItemDescription>
                  <PortfolioSectionItemLink
                    target="_blank"
                    rel="noreferrer"
                    href="https://dev.dercltsnhg5n2.amplifyapp.com/"
                  >
                    Go to Project
                  </PortfolioSectionItemLink>
                </PortfolioSectionItem>
                <PortfolioSectionItem>
                  <PortfolioSectionItemHeader>My Portfolio 😆</PortfolioSectionItemHeader>
                  <PortfolioSectionItemDescription></PortfolioSectionItemDescription>
                  <PortfolioSectionItemLink href={window.location.href}>
                    Go to Project
                  </PortfolioSectionItemLink>
                </PortfolioSectionItem>
              </PortfolioSectionBody>
            </PortfolioSection>
            <PortfolioSection>
              <PortfolioSectionHeader>Projects</PortfolioSectionHeader>
              <PortfolioSectionBody>
                <PortfolioSectionItem>
                  <PortfolioSectionItemHeader>C++ HTTP Server</PortfolioSectionItemHeader>
                  <PortfolioSectionItemDescription>
                    A basic implementation of an Hypertext Transfer Protocol (HTTP). It implements
                    the basic functionality of HTTP/1.1, allowing for retrieval and uploading of
                    files.
                  </PortfolioSectionItemDescription>
                  <PortfolioSectionItemLink
                    target="_blank"
                    rel="noreferrer"
                    href="https://github.com/jm4l1/jHttpServe"
                  >
                    Go to project
                  </PortfolioSectionItemLink>
                </PortfolioSectionItem>
                <PortfolioSectionItem>
                  <PortfolioSectionItemHeader>C++ JSON implementation</PortfolioSectionItemHeader>
                  <PortfolioSectionItemDescription>
                    Simple library implementation of Javascript Object Notation as described in RFC
                    8259 The JavaScript Object Notation (JSON) Data Interchange Format. This library
                    provides parsing and generating of JSON types
                  </PortfolioSectionItemDescription>
                  <PortfolioSectionItemLink
                    target="_blank"
                    rel="noreferrer"
                    href="https://github.com/jm4l1/jjson"
                  >
                    Go to project
                  </PortfolioSectionItemLink>
                </PortfolioSectionItem>
                <PortfolioSectionItem>
                  <PortfolioSectionItemHeader>C++ SIP implementation</PortfolioSectionItemHeader>
                  <PortfolioSectionItemDescription>
                    [WIP] - SIP Implementation based on protocol specifications in RFC3261
                  </PortfolioSectionItemDescription>
                  <PortfolioSectionItemLink
                    target="_blank"
                    rel="noreferrer"
                    href="https://github.com/jm4l1/jsip"
                  >
                    Go to project
                  </PortfolioSectionItemLink>
                </PortfolioSectionItem>
                <PortfolioSectionItem>
                  <PortfolioSectionItemHeader>C++ SDP implementation</PortfolioSectionItemHeader>
                  <PortfolioSectionItemDescription>
                    Simple library implementation of Session Description Protocol RFC 4566 SDP:
                    Session Description Protocol. This library provides parsing and generating of
                    SDP that can be used with other session protocols such as SIP.
                  </PortfolioSectionItemDescription>
                  <PortfolioSectionItemLink
                    target="_blank"
                    rel="noreferrer"
                    href="https://github.com/jm4l1/jsdp"
                  >
                    Go to project
                  </PortfolioSectionItemLink>
                </PortfolioSectionItem>
                <PortfolioSectionItem>
                  <PortfolioSectionItemHeader>C Based Network Simulator</PortfolioSectionItemHeader>
                  <PortfolioSectionItemDescription>
                    TCP/IP network stack simulator implemented in C. The simulator implements Basic
                    Layer 2 (MAC Addresses, Arp) and Layer 3 (Routing , IPs) functionality.
                  </PortfolioSectionItemDescription>
                  <PortfolioSectionItemLink
                    target="_blank"
                    rel="noreferrer"
                    href="https://github.com/jm4l1/tcpip_stack"
                  >
                    Go to project
                  </PortfolioSectionItemLink>
                </PortfolioSectionItem>
                <PortfolioSectionItem>
                  <PortfolioSectionItemHeader>Python packet analyser</PortfolioSectionItemHeader>
                  <PortfolioSectionItemDescription>
                    Packet analyser to read "pcap" files and parse according to given protocol such
                    as SIP
                  </PortfolioSectionItemDescription>
                  <PortfolioSectionItemLink
                    target="_blank"
                    rel="noreferrer"
                    href="https://github.com/jm4l1/packetanalyser"
                  >
                    Go to project
                  </PortfolioSectionItemLink>
                </PortfolioSectionItem>
              </PortfolioSectionBody>
            </PortfolioSection>
            <PortfolioSection>
              <PortfolioSectionHeader>Courses</PortfolioSectionHeader>
              <PortfolioSectionBody>
                <PortfolioSectionItem>
                  <PortfolioSectionItemHeader>
                    ELET3255 - Wireless Communications
                  </PortfolioSectionItemHeader>
                  <PortfolioSectionItemDescription></PortfolioSectionItemDescription>
                  <PortfolioSectionItemLink
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.jamalmoore.me/courses/elet3255"
                  >
                    Course page
                  </PortfolioSectionItemLink>
                </PortfolioSectionItem>
                <PortfolioSectionItem>
                  <PortfolioSectionItemHeader>
                    SWEN2003 - Computer Networking & Security
                  </PortfolioSectionItemHeader>
                  <PortfolioSectionItemDescription></PortfolioSectionItemDescription>
                  <PortfolioSectionItemLink
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.jamalmoore.me/courses/swen2003"
                  >
                    Course page
                  </PortfolioSectionItemLink>
                </PortfolioSectionItem>
              </PortfolioSectionBody>
            </PortfolioSection>
            <PortfolioSection>
              <PortfolioSectionHeader>Volunteerism</PortfolioSectionHeader>
              <PortfolioSectionBody>
                <PortfolioSectionItem>
                  <PortfolioSectionItemHeader>Coder Dojo Barbados</PortfolioSectionItemHeader>
                  <PortfolioSectionItemDescription>
                    CoderDojo Barbados Powered by Digicel
                  </PortfolioSectionItemDescription>
                  <PortfolioSectionItemLink
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.facebook.com/media/set/?set=a.10154632010327053.1073741949.92112537052&type=3"
                  >
                    Go to project
                  </PortfolioSectionItemLink>
                </PortfolioSectionItem>
              </PortfolioSectionBody>
            </PortfolioSection>
          </PortfolioBody>
        </PageBody>
      </Page>
    </AppContainer>
  );
});
